// @ts-nocheck
/* eslint-disable */
export const asDotIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="4" fill="currentColor"/></svg>`,
    name: 'dot' as const
};